
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 753.17 748.89"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M743.7 690.19L511.12 458.25c-.42-.42-.84-.84-1.34-1.26 35.53-47 56.43-106 56.77-171.4C574.91 133.69 439.38.59 283 0 134.8-.5 2 128.09 0 274c-2.15 162.77 123.68 292.19 284.21 292.52 67.8.08 129.09-22.07 177-59.95a7.52 7.52 0 00.75.83l232.58 231.96a32.6 32.6 0 0046.07 0l3.09-3a32.85 32.85 0 000-46.17zM285.38 521.38c-136.86.75-238.87-107.19-236.94-236.61C48.1 151.58 150.85 48.66 284.38 48.49c133.27-.17 238.45 103.34 237.95 235.1-.43 118.41-87.04 237.03-236.95 237.79z","fill":"#2c73e7","data-name":"Calque 1"}})])])
          )
        }
      }
    